import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"

import { Psychologist, RequestStatus } from "utils/interfaces"
import { Spinner } from "components/Spinner"
import { SurveyResultsPage } from "modules/SelectionOfPsychologists/SurveyResultsPage"
import { Cards } from "modules/SelectionOfPsychologists/Cards"
import { Layout } from "components"
import { getPsyCollection } from "modules/PsychologistsCollection/api"
import style from "modules/PsychologistsCollection/style.module.scss"
import { formatText } from "modules/PsychologistsCollection/helpers/formatText"
import { isBookingAvailable } from "utils/bookingAvailable"
import { useDidMount, useSearchParams } from "utils/customHooks"
import { APP_STATUSES, useAppStatusContext } from "utils/AppStatusContext"

export function PsychologistsCollection() {
    const searchParams = useSearchParams()
    const { id } = useParams<{ id: string }>()
    const [, { push }] = useAppStatusContext()
    const parsedId = +(id ?? searchParams.get("id") ?? "")
    const [profiles, setProfiles] = useState<Psychologist[]>([])
    const [headerText, setHeaderText] = useState<string | null>(null)
    const [description, setDescription] = useState<string | null>(null)
    const [status, setStatus] = useState<RequestStatus>("idle")

    useDidMount(() => {
        setStatus("loading")
        if (parsedId > 0) {
            getPsyCollection(parsedId)
                .then(({ result }) => {
                    if (result.profiles.some((psy) => isBookingAvailable(psy))) {
                        setProfiles(result.profiles.filter((psy) => isBookingAvailable(psy)))
                    } else {
                        setProfiles(result.profiles)
                    }
                    setHeaderText(result?.header)
                    setDescription(result?.description)
                    setStatus("ready")
                })
                .catch(() => setStatus("error"))
        }
    })

    useEffect(() => {
        if (status === "error") {
            push?.(APP_STATUSES.error)
        }
    }, [status])

    return (
        <Layout className="search-results">
            {(() => {
                switch (status) {
                    case "loading":
                        return <Spinner text="Загрузка психологов" />
                    case "ready":
                        return (
                            <>
                                <SurveyResultsPage
                                    header={<>{headerText || formatText(profiles.length)}</>}
                                    body={
                                        <>
                                            {description && (
                                                <div className={style.description}>
                                                    {description}
                                                </div>
                                            )}
                                            <Cards profiles={profiles} />
                                        </>
                                    }
                                />
                            </>
                        )
                    default:
                        return null
                }
            })()}
        </Layout>
    )
}
